<template>
    <div>
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>
                <span class="page-title">理财系统</span>
            </el-breadcrumb-item>
            <el-breadcrumb-item>挖矿宝</el-breadcrumb-item>
            <el-breadcrumb-item>灵活挖矿</el-breadcrumb-item>
        </el-breadcrumb>

        <el-button type="primary" @click="addMiningConfigDialog" style="margin: 20px 0">增 加</el-button>

        <el-table border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}"
                  :data="dataList" :row-key="() => Math.random()">
            <el-table-column prop="coinType" fixed="left" label="币种"></el-table-column>
            <el-table-column prop="incomeCoin" label="收益币种"></el-table-column>
            <el-table-column prop="cycle" label="解锁期限"></el-table-column>
            <el-table-column prop="minAmount" label="最小存入数"></el-table-column>
            <el-table-column prop="scale" label="小数位" show-overflow-tooltip></el-table-column>
            <el-table-column prop="sort" label="优先级" show-overflow-tooltip></el-table-column>
            <el-table-column prop="showed" label="上/下架" show-overflow-tooltip>
                <template slot-scope="scope">
                    <el-switch :value="scope.row.showed" active-color="#13ce66" inactive-color="#ff4949"
                               @change="alterShowed(scope.row.id,$event)"/>
                </template>
            </el-table-column>
            <el-table-column prop="status" label="转入状态" show-overflow-tooltip>
                <template slot-scope="scope">
                    <el-switch :value="scope.row.status" active-color="#13ce66" inactive-color="#ff4949"
                               @change="alterStatus(scope.row.id,$event)"/>
                </template>
            </el-table-column>
            <el-table-column label="创建时间">
                <template slot-scope="scope">
                    <span>{{scope.row.createTime | moment}}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" width="280">
                <template slot-scope="scope">
                    <el-button type="primary" @click="updateDialog(scope.row)">编辑</el-button>
                    <el-button type="danger" @click="unLockUserMining(scope.row.id)">一键解锁用户锁仓</el-button>
                    <el-button type="danger" @click="deleteUserMiningConfig(scope.row.id)">删除</el-button>

                </template>
            </el-table-column>
        </el-table>

        <el-dialog :title="title" :visible.sync="dialogVisible" width="800px" @close="clearData"
                   :close-on-click-modal="false">
            <el-form label-width="150px" :model="addData" :rules="addRules" ref="addForm">
                <el-form-item label="币种：" prop="coinType" style="padding-top: 20px">
                    <el-autocomplete class="inline-input" style="width: 500px"
                                     v-model="addData.coinType"
                                     :fetch-suggestions="querySearch"
                                     placeholder="请输入币种">
                        <i class="el-icon-close el-input__icon" slot="suffix"
                           @click="cleanSearchCoin" style="cursor:pointer;">
                        </i>
                    </el-autocomplete>
                </el-form-item>
                <el-form-item label="收益币种：" prop="inComeCoin" style="padding-top: 20px">
                    <el-input v-model="addData.inComeCoin" placeholder="收益币种，多个逗号隔开" style="width: 500px"></el-input>
                </el-form-item>
                <el-form-item label="最小存入数：" prop="minAmount" style="padding-top: 20px">
                    <el-input v-model="addData.minAmount" placeholder="最小存入数(正整数：0＜X≤999999999)"
                              style="width: 500px"></el-input>
                </el-form-item>
                <el-form-item label="小数位：" prop="scale" style="padding-top: 20px">
                    <el-input v-model="addData.scale" placeholder="小数位(正整数：0＜X≤8)" style="width: 500px"></el-input>
                </el-form-item>
                <el-form-item label="优先级：" prop="sort" style="padding-top: 20px">
                    <el-input v-model="addData.sort" placeholder="优先级(正整数：0＜X≤999999999)"
                              style="width: 500px"></el-input>
                </el-form-item>
                <el-form-item label="解锁周期：" prop="cycle" style="padding-top: 20px">
                    <el-input v-model="addData.cycle" placeholder="解锁周期(正整数：0＜X≤999)" style="width: 500px"></el-input>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button type="danger" :loading="loading" @click="addMiningConfig">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import './store';
    import api from './api';

    export default {
        name: 'Flexible',
        data() {
            return {
                dataList: [],
                coinTypes: [],
                loading: false,
                dialogVisible: false,
                addData: {
                    id: "",
                    coinType: "",
                    inComeCoin: "",
                    minAmount: "",
                    scale: "",
                    sort: "",
                    cycle:""

                },
                addRules: {
                    "coinType": [{required: true, message: "请输入币种"}],
                    "inComeCoin": [{required: true, message: "请输入收益币种"}],
                    "minAmount": [{required: true, message: "请输入最小存入数"}],
                    "scale": [{required: true, message: "请输入小数位"}],
                    "sort": [{required: true, message: "请输入优先级"}],
                    "cycle": [{required: true, message: "请输入解锁周期"}]

                },
                title: "新增"

            }
        },
        methods: {
            getAllSupportCoin() {
                api.getAllSupportCoin().then(({data}) => {
                    this.coinTypes = data;
                });
            },
            getUserMiningConfigList() {
                api.getUserMiningConfigList().then(({data}) => {
                    this.dataList = data;
                });
            },
            addMiningConfigDialog() {
                this.title = "新增";
                this.dialogVisible = true;
            },
            updateDialog(row) {
                this.title = "修改";
                this.addData = {
                    id: row.id,
                    coinType: row.coinType,
                    inComeCoin: row.incomeCoin,
                    minAmount: row.minAmount,
                    scale: row.scale,
                    sort: row.sort,
                    cycle: row.cycle,
                };
                this.dialogVisible = true;
            },
            alterShowed(id, showed) {
                this.$confirm(showed ? '确认上架吗？' : '确认下架吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    api.updateMiningConfigShowed({id: id, showed: showed}).then(() => {
                        this.$message.success('操作成功');
                        this.getUserMiningConfigList();
                    });
                }).catch(() => {
                });
            },
            alterStatus(id, status) {
                this.$confirm(status ? '确认启用吗？' : '确认停用吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    api.updateMiningConfigStatus({id: id, status: status}).then(() => {
                        this.$message.success('操作成功');
                        this.getUserMiningConfigList();
                    });
                }).catch(() => {
                });
            },
            unLockUserMining(id) {
                this.$confirm('确认一键解锁用户锁仓吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    api.adminUnLockUserMining({id: id}).then(() => {
                        this.$message.success('操作成功');
                        this.getUserMiningConfigList();
                    });
                }).catch(() => {
                });
            },

            deleteUserMiningConfig(id) {
                this.$confirm('确认删除灵活挖矿配置吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    api.deleteUserMiningConfig({id: id}).then(() => {
                        this.$message.success('操作成功');
                        this.getUserMiningConfigList();
                    });
                }).catch(() => {
                });
            },


            addMiningConfig() {
                this.$refs["addForm"].validate(valid => {
                    if (valid) {
                        this.loading = true;
                        api.createOrUpdateMiningConfig(this.addData).then(({data}) => {
                            this.$message.success('操作成功!');
                            this.loading = false;
                            this.dialogVisible = false;
                            this.getUserMiningConfigList();
                        });
                        setTimeout(()=>{
                            this.loading = false;
                        },1000);
                    }
                });
            },
            querySearch(queryString, cb) {
                var results = [];
                var coinList = this.coinTypes;
                results = queryString ? coinList.filter(this.createFilter(queryString)) : coinList;
                results = results.map((v, i, arr) => {
                    return {
                        value: v
                    }
                });
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            createFilter(queryString) {
                let tempData = this.coinTypes;
                return (tempData) => {
                    return (tempData.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            cleanSearchCoin() {
                this.addData.coinType = '';
            },
            clearData() {
                this.$refs["addForm"].resetFields();
                this.loading = false;
                this.title = "新增";
                this.addData = {
                    id: "",
                    coinType: "",
                    inComeCoin: "",
                    minAmount: "",
                    scale: "",
                    sort: ""
                };
            }
        },
        created() {
            this.getUserMiningConfigList();
            this.getAllSupportCoin();
        }
    };
</script>

<style lang="less" scoped>

</style>
